<template>
  <div class="card" v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職歴を入力</h2>
        <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
        <el-checkbox v-model="formatData.notDisplayIjyo"
          >【以上】を表示しない</el-checkbox
        >
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <div class="add-item">
            <AutoJobHistories
              :birth-year="basicData.birthYear"
              :birth-month="basicData.birthMonth"
              :birth-day="basicData.birthDay"
              @job-histories-created="setJobHistories"
            />
            <div class="button-reset">
              <el-button
                v-if="
                  formatData.jobHistories && formatData.jobHistories.length > 1
                "
                @click="jobResetVisible = true"
                >リセット</el-button
              >
            </div>
            <NewRirekishoResetDialog
              :value="jobResetVisible"
              name="job-reset"
              title="職歴リセット"
              message="現在入力されている職歴をすべて削除します。よろしいですか？"
              @input="jobResetVisible = $event"
              @confirm="resetJobHistories"
            />
          </div>
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.jobHistories"
              :key="item.uuid"
              :item="item"
              :length="formatData.jobHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'職歴を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @add-history-item="addJobHistory"
              @delete-history-item="deleteJobHistory"
              @move-history-item="moveJobHistory"
              @click.native="activateHistoryItem(item.uuid)"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addJobHistory()"
            />
          </div>
        </div>
        <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
          <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoJobHistories from '@/components/formats/RirekishoParts/AutoJobHistories.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'

const descriptionMaxLength = 80

defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
  previewErrors: Record<string, string>
}>()

const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  setJobHistories,
  resetJobHistories,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const jobResetVisible = ref(false)
</script>
